import { LiveEventShopItemConfig, LevelRewardInput, LevelRewardInputType, LiveEventShopItemInput } from "../../../../../__gqltypes__";
import { EventMatchersConfig, userIdsStringToArray } from "../../general/EventMatchers";
import { DetectedLiveChanges } from "../Marathon/utils";

export function convertLiveEventShopItemToLevelRewardInput(reward: LiveEventShopItemConfig): LevelRewardInput {
  return  {
      type: Object.values(LevelRewardInputType)
      .find((val) => val === reward.type.toString()) ?? LevelRewardInputType.CURRENCY_COIN,
      amount: reward.amount,
      itemId: reward.itemId,
  };
}

export function convertLiveEventShopItemToInputs(
  rewards: Array<LiveEventShopItemConfig>
): Array<LiveEventShopItemInput> {
  return rewards.map((reward) => {
    return { item: convertLiveEventShopItemToLevelRewardInput(reward), cost: reward.cost, buyLimit: reward.buyLimit };
  });
}

// Everything the main Save can change, to warn before editing an event players are in.
export type LiveEventEditSnapshot = {
  name: string;
  startDate: Date | null;
  endDate: Date | null;
  isDraft: boolean;
  filterOnlyAdmin: boolean;
  matchers: EventMatchersConfig;
};

const epoch = (date: Date | string | null | undefined): number | null => (date ? new Date(date).getTime() : null);

// Stable signature of the audience matchers; absent and '>=' operators behave the same
export function liveEventMatcherSignature(cfg: EventMatchersConfig): string {
  return JSON.stringify({
    appVersion: cfg.filterAppVersion || null,
    appVersionOperator: cfg.filterAppVersion ? cfg.filterAppVersionOperator ?? '>=' : null,
    subscriptionTier: cfg.filterSubscriptionTier ?? null,
    userIds: (userIdsStringToArray(cfg.filterUserIds ?? '') ?? []).join(','),
    userLevel: cfg.filterUserLevel ?? null,
    userMinCreationDate: epoch(cfg.filterUserMinCreationDate),
    userMaxCreationDate: epoch(cfg.filterUserMaxCreationDate),
  });
}

// HIGH = can take the event away from players mid-way (their currency and purchases stay in the DB
// but they no longer see the event) or move it under their feet.
export function detectLiveEventDataChanges(
  before: LiveEventEditSnapshot,
  after: LiveEventEditSnapshot
): DetectedLiveChanges {
  const high: string[] = [];
  const low: string[] = [];

  if (epoch(before.startDate) !== epoch(after.startDate) || epoch(before.endDate) !== epoch(after.endDate)) {
    high.push('event dates (start / end)');
  }
  if (!before.isDraft && after.isDraft) {
    high.push('set back to draft: the event disappears for every player');
  }
  if (!before.filterOnlyAdmin && after.filterOnlyAdmin) {
    high.push('admin only: the event disappears for every non-admin player');
  }
  if (liveEventMatcherSignature(before.matchers) !== liveEventMatcherSignature(after.matchers)) {
    high.push('audience matchers: players who stop matching lose the event mid-way');
  }
  if (before.name !== after.name) {
    low.push('event name');
  }

  return { high, medium: [], low };
}
